<form [formGroup]="configurationsFormGroup" (ngSubmit)="onSubmit()">
  <div class="p-dialog-body overflow-hidden">
    <div
      class="border-style-solid border-1 border-gray-200 rounded-px-5 vh-334 overflow-auto"
      cdkScrollable
    >
      <div
        class="d-flex bg-gray-50 rounded-top-start-5 rounded-top-end-5 position-sticky top-0 z-index-1"
      >
        <div
          scope="col"
          class="fs-15 fw-semibold px-3 py-12 width-5 min-w-5 bg-gray-50"
        >
          {{ 'configurations.page.headers.order' | t }}
        </div>
        <div
          scope="col"
          class="fs-15 fw-semibold px-3 py-12 width-10 min-w-10 bg-gray-50"
        >
          {{ 'configurations.page.headers.show_hide' | t }}
        </div>
        <div
          scope="col"
          class="flex-1 fs-15 fw-semibold px-3 py-12 min-w-11 bg-gray-50"
        >
          {{ 'configurations.page.headers.schema_name' | t }}
        </div>
        <div
          scope="col"
          class="flex-1 fs-15 fw-semibold px-3 py-12 min-w-11 bg-gray-50"
        >
          {{ 'configurations.page.headers.display_name' | t }}
        </div>
        <div
          scope="col"
          class="fs-15 fw-semibold px-3 py-12 width-10 min-w-10 bg-gray-50"
        >
          {{ 'configurations.page.headers.is_sortable' | t }}
        </div>
      </div>
      <div cdkDropList formArrayName="configurations" [cdkDropListAutoScrollDisabled]="false"
        [cdkDropListAutoScrollStep]="10" (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let configuration of configurations.controls; let i = index">
          <div class="d-flex bg-white " [formGroupName]="i" cdkDrag>
            <div
              class="px-3 py-12 width-5 min-w-5 border-end-1 border-end-style-solid border-gray-200 d-flex align-items-center justify-content-center"
            >
              <span
                class="fa fa-grip-vertical color-gray-500 fs-14 cursor-move"
                title="Change Order"
              ></span>
            </div>
            <div
              class="px-3 py-12 width-10 min-w-10 d-flex align-items-center justify-content-center border-end-1 border-end-style-solid border-gray-200"
            >
              <div class="height-px-20">
                <input type="hidden" formControlName="id" />
                <p-toggleswitch formControlName="isShown"></p-toggleswitch>
              </div>
            </div>
            <div class="px-3 py-12 flex-1 border-end-1 border-end-style-solid border-gray-200 min-w-11">
              <input formControlName="schemaName"  class="d-block w-100" pInputText />
            </div>
            <div class="px-3 py-12 flex-1 border-end-1 border-end-style-solid border-gray-200 min-w-11">
              <input formControlName="displayName"  class="d-block w-100" pInputText />
              <div
                class="invalid-feedback"
                [ngClass]="
                  isSubmitted ||
                  (configurations.controls[i].get('displayName')?.touched &&
                    configurations.controls[i].get('displayName')?.invalid)
                    ? 'd-block'
                    : 'd-none'
                "
              >
                <span
                  *ngIf="
                    configurations.controls[i]
                      .get('displayName')
                      ?.hasError('required')
                  "
                  >{{ 'configurations.page.validation.display_name_required' | t }}</span
                >
              </div>
            </div>


            <div
              class="px-3 py-12 width-10 min-w-10 d-flex align-items-center justify-content-center"
            >
              <div class="height-px-20">
                <p-toggleswitch formControlName="isSortable"></p-toggleswitch>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="p-dialog-footer border-top-0">
    <p-button
      type="button"
      severity="secondary"
      variant="text"
      (onClick)="onCancel($event)"
      label=" {{ 'common.actions.buttons.cancel' | t }}"
    >
    </p-button>

    <p-button
      type="submit"
      [disabled]="configValidityCheck()"
      (onClick)="configValidityCheck()"
      label="{{ 'common.actions.buttons.save' | t }}"
    >
    </p-button>
  </div>
</form>